module.exports = __webpack_public_path__ + "img/img_16.8440fa66.png";